<div appDisableBodyScroll class="bottom-dialog" *ngIf="showCityPopup">
  <div class="bottom-dialog-content">
    <div class="d-flex justify-content-between">
      <p class="mb-0"><b>Select a City</b></p>
      <fa-icon *ngIf="openCity" (click)="toggleCity()" [icon]="faTimes"></fa-icon>
    </div>
    <hr>
    <app-city-content [cities]="cities" (citySelected)="onCitySelected($event)"></app-city-content>
  </div>
</div>